import { CognitoUser, CognitoUserPool } from "amazon-cognito-identity-js";
import { environment } from "environments/environment";

const USER_POOL_ID = environment.USER_POOL_ID;
const CLIENT_ID = environment.CLIENT_ID;

export const userPool: CognitoUserPool = new CognitoUserPool({
	UserPoolId: USER_POOL_ID,
	ClientId: CLIENT_ID
});

export function createUserData(user: string) {
	return new CognitoUser({
		Username: user,
		Pool: userPool
	});
}
